import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import SelectField from 'components/forms/selectField/SelectField';
import { TriggerType } from 'models/automation/Triggers';
import { orderBy } from 'utils/arrayUtils';
import { EVENT_TYPE_OPTIONS } from '../TriggersTab.constants';
import { TriggerAddEditModalFormValues } from './TriggerAddEditModal.schema';
import { useTriggerAddEditModalContext } from './TriggerAddEditModalContext';

const TriggerAddEditModalEventTypeField = () => {
  const { t } = useTranslation();
  const { control, setValue } = useFormContext<TriggerAddEditModalFormValues>();
  const triggerType = useWatch({ control, name: 'triggerType' });
  const { conditionsFieldArray } = useTriggerAddEditModalContext();
  const { remove } = conditionsFieldArray;

  if (triggerType === TriggerType.TIME_BASED) {
    return null;
  }

  const eventTypeOptions = EVENT_TYPE_OPTIONS.map((event) => ({
    label: t('pageAutomations.triggers.eventType', { context: event }),
    value: event,
  }));

  const options = [
    { label: t('pageAutomations.triggers.eventType'), value: '' },
    ...orderBy(eventTypeOptions, [{ field: 'label', order: 'asc' }]),
  ];

  const handleEventTypeChange = () => {
    remove();
    setValue('actionType', '', { shouldDirty: true });
    setValue('jobTiming', '', { shouldDirty: true });
    setValue('recipientsList', [], { shouldDirty: true });
    setValue('serviceUid', '', { shouldDirty: true });
    setValue('templateUid', '', { shouldDirty: true });
  };

  return (
    <SelectField
      colSmInput={12}
      label={t('pageAutomations.triggers.modal.eventType')}
      labelOnTop
      name="eventType"
      onChangeHandler={handleEventTypeChange}
      options={options}
      required
    />
  );
};

export default TriggerAddEditModalEventTypeField;
